/* eslint-disable no-param-reassign, arrow-body-style */
// @flow

// Since we need to serialize the ColumnsDefinition we need
// to cleanup the `columns` prop comming fro Wijmo`s Grid.

import type { ColumnsMap } from '../types';

const filterColPropertiesToBeSaved = (
  data: ColumnsMap,
  exclude: Array<string> = [],
) => {
  if (!data) return undefined;

  const mappers = [
    'header',
    'binding',
    'isReadOnly',
    'visible',
    'wordWrap',
    'size',
    'align',
    'format',
    'isContentHtml',
    'currentSort',
    'aggregate',
  ];

  return data.map(item => {
    return mappers
      .filter(key => exclude.indexOf(key) === -1)
      .reduce((reducer, key) => {
        if (key === 'currentSort') {
          reducer[key] = item[key] === null ? '' : item[key];
        } else if (key === 'aggregate') {
          reducer[key] = item[key] || item[key] === 0 ? 'None' : item[key]
        } else {
          reducer[key] = item[key];
        }

        return reducer;
      }, {});
  });
};

export { filterColPropertiesToBeSaved };
